import {
  Identifiable,
  Planzone,
  ProjectMembersListingConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getDefaultConf(): ProjectMembersListingConfiguration {
  return [
    {
      name: "Admin",
      roles: ["pz_admin"],
      columns: [{ key: "tags" }, { key: "role" }],
    },
    {
      name: "Others",
      roles: [
        "pz_under_admin",
        "pz_user",
        "pz_visitor",
        "pr_visitor",
        "pr_manager",
        "pr_worker",
      ],
      columns: [{ key: "tags" }, { key: "role" }],
    },
  ];
}

function getProjectMembersListingConfiguration(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ data }) =>
        !!data.projectMembersListingViewConfigurations
          ? JSON.parse(data.projectMembersListingViewConfigurations)
          : getDefaultConf(),
      );
}

export { getProjectMembersListingConfiguration };
